<script setup lang="ts">
import { Button } from "@/components/ui/button";
import { passkeyLogin } from "@auth-frontend-vue/lib/auth.actions";
import { hasPasskeyUsedLocally } from "@auth-frontend-vue/lib/passkeyLocalStorage";
import { Fingerprint, Loader2 } from "lucide-vue-next";
import { ref } from "vue";
import { toast } from '@/ui-plus/sonner';
import { browserSupportsWebAuthn } from '@simplewebauthn/browser';

const showPasskeyButton = browserSupportsWebAuthn() && hasPasskeyUsedLocally();
const isLoading = ref(false);

async function onPasskeyClick() {
	if (isLoading.value) return;
	isLoading.value = true;
	try {
		const { error } = await passkeyLogin();
		if (error && error.code !== 'PASSKEY_CANCELLED') {
			toast.error(error.message ?? 'Passkey sign-in failed');
		}
	} finally {
		isLoading.value = false;
	}
}
</script>

<template>
	<Button v-if="showPasskeyButton"
			class="w-full p-6 font-bold text-2xl"
			variant="outline"
			:disabled="isLoading"
			@click="onPasskeyClick">
		<Loader2 v-if="isLoading"
				 class="h-6 w-6 animate-spin" />
		<Fingerprint v-else
					 class="min-h-8 min-w-8" />
		Sign in with passkey
	</Button>
</template>
